import {priority, wcfclient} from '@priority-software/priority-proto-api/lib';
import {Options, callServer} from '../../services/proto/core/server';
import {ServerMethods} from '../../services/proto/core/constants';
import {getAdditionalProps} from '../../services/proto/core/loginProps';

export const fetchTableViewColumnsDesign = async (
    formName: string,
    mainForm: string,
    options?: Partial<Options>
): Promise<priority.netitems.form.TableViewColumnsDesignRs> => {
    return callServer(
        wcfclient.TableViewColumnsDesign,
        new priority.netitems.form.TableViewColumnsDesignRq({
            Properties: getAdditionalProps(),
            FormName: formName,
            MainFormName: mainForm
        }),
        ServerMethods.TableViewColumnsDesignRq,
        options
    );
};

export const saveTableViewColumnsDesign = async (
    columnsDesign: priority.netitems.form.ITableViewColumnsDesign[],
    formName: string,
    mainForm: string,
    options?: Partial<Options>
): Promise<priority.netitems.form.SaveTableViewColumnsDesignRs> => {
    return callServer(
        wcfclient.SaveTableViewColumnsDesign,
        new priority.netitems.form.SaveTableViewColumnsDesignRq({
            Properties: getAdditionalProps(),
            ColumnsDesign: columnsDesign,
            FormName: formName,
            MainFormName: mainForm
        }),
        ServerMethods.SaveTableViewColumnsDesignRq,
        options
    );
};

export const fetchRowViewColumnsDesign = async (
    formName: string,
    mainForm: string,
    options?: Partial<Options>
): Promise<priority.netitems.form.RowViewColumnsDesignRs> => {
    return callServer(
        wcfclient.RowViewColumnsDesign,
        new priority.netitems.form.RowViewColumnsDesignRq({
            Properties: getAdditionalProps(),
            FormName: formName,
            MainFormName: mainForm
        }),
        ServerMethods.RowViewColumnsDesignRq,
        options
    );
};

export const fetchActionsDesign = async (
    formName: string,
    mainForm: string,
    options?: Partial<Options>
): Promise<priority.netitems.form.ActionsDesignRs> => {
    return callServer(
        wcfclient.ActionsDesign,
        new priority.netitems.form.ActionsDesignRq({
            Properties: getAdditionalProps(),
            FormName: formName,
            MainFormName: mainForm
        }),
        ServerMethods.ActionsDesignRq,
        options
    );
};

export const saveActionsDesign = async (
    actionsDesign: priority.netitems.form.IMenuDesign[],
    formName: string,
    mainForm: string,
    options?: Partial<Options>
): Promise<priority.netitems.form.SaveActionsDesignRs> => {
    return callServer(
        wcfclient.SaveActionsDesign,
        new priority.netitems.form.SaveActionsDesignRq({
            Properties: getAdditionalProps(),
            FormName: formName,
            ActionsDesign: actionsDesign,
            MainFormName: mainForm
        }),
        ServerMethods.SaveActionsDesignRq,
        options
    );
};

export const fetchSubformsDesign = async (
    formName: string,
    mainForm: string,
    options?: Partial<Options>
): Promise<priority.netitems.form.SubformsDesignRs> => {
    return callServer(
        wcfclient.SubformsDesign,
        new priority.netitems.form.SubformsDesignRq({
            Properties: getAdditionalProps(),
            FormName: formName,
            MainFormName: mainForm
        }),
        ServerMethods.SubformsDesignRq,
        options
    );
};

export const saveSubformsDesign = async (
    subformsDesign: priority.netitems.form.IMenuDesign[],
    formName: string,
    mainForm: string,
    options?: Partial<Options>
): Promise<priority.netitems.form.SaveSubformsDesignRs> => {
    return callServer(
        wcfclient.SaveSubformsDesign,
        new priority.netitems.form.SaveSubformsDesignRq({
            Properties: getAdditionalProps(),
            FormName: formName,
            SubformsDesign: subformsDesign,
            MainFormName: mainForm
        }),
        ServerMethods.SaveSubformsDesignRq,
        options
    );
};

export const saveRowViewColumnsDesign = async (
    tabDesign: priority.netitems.form.RowViewTabsDesign[],
    formName: string,
    mainForm: string,
    pic: priority.netitems.form.Picture,
    options?: Partial<Options>
): Promise<priority.netitems.form.SaveRowViewColumnsDesignRs> => {
    return callServer(
        wcfclient.SaveRowViewColumnsDesign,
        new priority.netitems.form.SaveRowViewColumnsDesignRq({
            Properties: getAdditionalProps(),
            TabsDesign: tabDesign,
            FormName: formName,
            MainFormName: mainForm,
            Picture: pic
        }),
        ServerMethods.SaveRowViewColumnsDesignRq,
        options
    );
};

export const restoreDesign = async (
    formName: string,
    mainForm: string,
    designType: priority.netitems.form.DesignType,
    options?: Partial<Options>
): Promise<priority.netitems.form.RestoreDefaultDesignRs> => {
    return callServer(
        wcfclient.RestoreDefaultDesign,
        new priority.netitems.form.RestoreDefaultDesignRq({
            Properties: getAdditionalProps(),
            FormName: formName,
            MainFormName: mainForm,
            DesignType: designType
        }),
        ServerMethods.RestoreDefaultDesignRq,
        options
    );
};

export const systemPackages = async (
    options?: Partial<Options>
): Promise<priority.netitems.ngen.SystemPackagesRs> => {
    return callServer(
        wcfclient.SystemPackages,
        new priority.netitems.ngen.SystemPackagesRq({
            Properties: getAdditionalProps()
        }),
        ServerMethods.SystemPackagesRq,
        options
    );
};

export const packageChange = async (
    packageId: number,
    isPackageVisible: boolean,
    options?: Partial<Options>
): Promise<priority.netitems.ngen.PackageChangeRs> => {
    return callServer(
        wcfclient.PackageChange,
        new priority.netitems.ngen.PackageChangeRq({
            PackageId: packageId,
            IsPackageVisible: isPackageVisible,
            Properties: getAdditionalProps()
        }),
        ServerMethods.PackageChangeRq,
        options
    );
};

export const packageSet = async (
    packages: priority.netitems.ngen.Package[],
    options?: Partial<Options>
): Promise<priority.netitems.ngen.PackageSetRs> => {
    return callServer(
        wcfclient.PackageSet,
        new priority.netitems.ngen.PackageSetRq({
            Packages: packages,
            Properties: getAdditionalProps()
        }),
        ServerMethods.PackageSetRq,
        options
    );
};
